import { NgModule } from '@angular/core';

import { AbsPipe } from '@mem-shared/pipes/abs.pipe';
import { AndLastPipe } from '@mem-shared/pipes/and-last.pipe';
import { CategoryIconPipe } from '@mem-shared/pipes/category-icon.pipe';
import { CentsPipe } from '@mem-shared/pipes/cents.pipe';
import { CfTelPipe } from '@mem-shared/pipes/cf-tel.pipe';
import { ContactPipe } from '@mem-shared/pipes/contact-number.pipe';
import { ConvertDollarToNumberPipe } from '@mem-shared/pipes/convert-dollar-to-number.pipe';
import { CurrencyFormatterPipe } from '@mem-shared/pipes/currency-formatter.pipe';
import { DateFromDetailsPipe } from '@mem-shared/pipes/date-from-details.pipe';
import { DateSortPipe } from '@mem-shared/pipes/date-sort.pipe';
import { EmptyToZeroPipe } from '@mem-shared/pipes/empty-to-zero.pipe';
import { OrderSubjectsPipe } from '@mem-shared/pipes/order-subjects.pipe';
import { PcpGenderIconPipe } from '@mem-shared/pipes/pcp-gender-icon.pipe';
import { PhonePipe } from '@mem-shared/pipes/phone-number.pipe';
import { RelativeDatePipe } from '@mem-shared/pipes/relative-date.pipe';
import { RemoveBracketPipe } from '@mem-shared/pipes/remove-bracket.pipe';
import { RoundcentsPipe } from '@mem-shared/pipes/roundcents.pipe';
import { SafeUrlPipe } from '@mem-shared/pipes/safe-url.pipe';
import { ZipCodePipe } from '@mem-shared/pipes/zip-code.pipe';
import { SanitizeHtmlPipe } from '@mem-shared/pipes/sanitize-html.pipe';

const pipes = [
  AbsPipe,
  AndLastPipe,
  CategoryIconPipe,
  CentsPipe,
  CfTelPipe,
  ContactPipe,
  ConvertDollarToNumberPipe,
  CurrencyFormatterPipe,
  DateFromDetailsPipe,
  DateSortPipe,
  EmptyToZeroPipe,
  OrderSubjectsPipe,
  PcpGenderIconPipe,
  PhonePipe,
  RelativeDatePipe,
  RemoveBracketPipe,
  RoundcentsPipe,
  SafeUrlPipe,
  SanitizeHtmlPipe,
  ZipCodePipe
];

@NgModule({
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/shared-pipes.module.ts